import { InfoCircleOutlined } from '@ant-design/icons';
import { ADMIN_BASE_BATH } from '@app/constants/variables';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import * as S from './ClientNav.styles';
import { ProfileNavItem } from '@app/constants/profileNavData';

const clientNavData: ProfileNavItem[] = [
  {
    id: 1,
    name: 'clients.form.clientInfo',
    icon: <InfoCircleOutlined />,
    color: 'primary',
    href: 'client-info',
  },
];

export const ClientNav: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();

  const [navData, setNavData] = useState<ProfileNavItem[]>([]);

  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    if (id) {
      setNavData(
        clientNavData.map((item) => ({
          ...item,
          href: `${item.href}/${id}`,
        })),
      );
    } else {
      setNavData(clientNavData);
    }
  }, [id]);

  return (
    <S.Wrapper>
      {navData.map((item) => (
        <S.Btn
          key={item.id}
          icon={item.icon}
          type="text"
          color={item.color}
          onClick={() => navigate(item.href)}
          isActive={`${ADMIN_BASE_BATH}/clients/${item.href}` === location.pathname}
        >
          {`${t(item.name)}`}
        </S.Btn>
      ))}
    </S.Wrapper>
  );
};
